//
// locales/glitch/en.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/flavours/glitch/locales/en';
import localeData from 'react-intl/locale-data/en.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
